// extracted by mini-css-extract-plugin
export default {"companyContainer":"SL-z","companyImage":"TL-z","container":"UL-z","heading":"VL-z","darkText":"WL-z","smallHeading":"XL-z","darkBackground":"YL-z","whiteBackground":"ZL-z"};